<template>
  <div class="header-box">
    <!-- 头部 -->
    <el-row>
      <!-- logo -->
      <el-col :span="3"><div class="addSpace"></div></el-col>
      <el-col :span="5">
        <div class="header_logo">
          <router-link :to="`/home`" style="display: inline-flex"
            ><img
              class="picture"
              referrerpolicy="no-referrer"
              src="~@/assets/images/BOSLogo.png"
          /></router-link>
        </div>
      </el-col>
      <el-col :span="3"><div class="addSpace"></div></el-col>
      <!-- 导航 -->
      <el-col :span="10">
        <div class="navigation">
          <el-menu
            :default-active="tabindex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="1" class="tabChooseSpaceOne"
              ><router-link :to="`/home`" class="tabChoose"
                >首页</router-link
              ></el-menu-item
            >
            <el-menu-item index="2" class="tabChooseSpaceTwo"
              ><router-link :to="`/good-service`" class="tabChoose"
                >优质服务</router-link
              ></el-menu-item
            >
            <el-menu-item index="3" class="tabChooseSpaceThree"
              ><router-link :to="`/classic-case`" class="tabChoose"
                >经典案例</router-link
              ></el-menu-item
            >
            <el-menu-item index="4" class="tabChooseSpaceFour"
              ><router-link :to="`/about`" class="tabChoose"
                >关于我们</router-link
              ></el-menu-item
            >
            <el-menu-item index="5" class="tabChooseSpaceFive"
              ><router-link :to="`/company-dynamics`" class="tabChoose"
                >公司动态</router-link
              ></el-menu-item
            >
          </el-menu>
        </div>
      </el-col>
      <el-col :span="3"><div class="addSpace"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["tabindex"],
  data() {
    return {
      activeIndex: "1", //默认选中导航
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style>
.el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #333333 !important;
  height: 77px !important;
  line-height: 77px !important;
  font-size: 16px !important;
}
.el-menu--popup {
  min-width: 120px !important;
}
.el-menu--popup .router-link-exact-active.router-link-active {
  color: #fe5f28 !important;
}

.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  text-align: center;
  letter-spacing: 2px;
  height: 56px !important;
  line-height: 56px !important;
  font-size: 16px !important;
  display: grid;
  padding: 0 !important;
}

.el-menu--horizontal > .el-menu-item {
  padding: 0 !important;
  height: 77px !important;
  line-height: 77px !important;
}

.el-menu--popup-bottom-start {
  /* margin-left: -11px; */
}

.el-menu-demo {
  height: 77px;
}

.navigation {
  display: flex;
  justify-content: flex-end;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 0.010417rem solid #a7823c !important;
  background: #a7823c !important;
  color: #fff !important;
}

.el-menu--horizontal > .el-menu-item.is-active a {
  color: #fff !important;
  background: #a7823c;
}
</style>
<style scoped lang="scss">
a {
  text-decoration: none;
  color: #333333;
}
.header-box {
  height: 100%;
  .header_logo {
    height: 77px;
    // margin-left: 31px;
    /* 让图片各方位居中 */
    display: flex;
    // justify-content: center;
    align-items: center;
    .picture {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .addSpace {
    height: 77px;
  }

  .navigation {
    .tabChoose {
      // width: 68px;
      height: 77px;
      display: block;
      text-decoration: none;
      color: #333333;
      font-size: 16px;
      padding: 0 19px;
    }
    ul {
      li {
        height: 77px;
        display: block;
        text-decoration: none;
        color: #333333;
        font-size: 16px;
        a {
          // text-decoration: none;
          // color: #333333;
        }
      }
    }
  }

  .tabChooseSpaceOne {
    margin-right: 80px;
  }

  .tabChooseSpaceTwo {
    margin-right: 75px;
  }

  .tabChooseSpaceThree {
    margin-right: 75px;
  }

  .tabChooseSpaceFour {
    margin-right: 75px;
  }

  .tabChooseSpaceFive {
  }
  .leterspaceStyle {
    margin: 0 10px;
  }
}

@media only screen and (max-width: 1600px) {
  // .header-box .header_logo {
  //   height: 0.55282rem;
  // }
  // .el-menu--horizontal > .el-menu-item {
  //   height: 0.55282rem !important;
  //   line-height: 0.55282rem !important;
  // }
  .tabChooseSpaceOne {
    margin-right: 50px !important;
  }

  .tabChooseSpaceTwo {
    margin-right: 50px !important;
  }

  .tabChooseSpaceThree {
    margin-right: 50px !important;
  }

  .tabChooseSpaceFour {
    margin-right: 50px !important;
  }
}
</style>
